import { View, Text } from "react-native";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import { Platform } from "react-native";

import Colours from "../../utils/Colours";
import HomeIcon from "../../icons/HomeIcon";
import UserProfileIcon from "../../icons/UserProfileIcon";
import HomeNavigation from "./HomeNavigation";
// import ProfileNavigation from "./ProfileNavigation";
import TableIcon from "../../icons/TableIcon";
import { lazyScreen } from "../../utils/lazyScreen";
// import TablesNavigation from "./TablesNavigation";

const ProfileNavigation = lazyScreen(() => import("./ProfileNavigation"));
const TablesNavigation = lazyScreen(() => import("./TablesNavigation"));

export default function TabNavigations() {
  const Tab = createBottomTabNavigator();

  return (
    <Tab.Navigator
      screenOptions={{
        headerShown: false,
        tabBarActiveTintColor: Colours.PRIMARY,

        tabBarStyle: {
          ...(Platform.OS === "web" && {
            // position: "fixed",
            position: "sticky", // ← use sticky instead of fixed

            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 999,
          }),
        },
      }}
    >
      <Tab.Screen
        name="home"
        component={HomeNavigation}
        options={{
          tabBarLabel: ({ color }) => (
            <Text
              style={{
                fontSize: 15,
                marginTop: -5,
                marginBottom: 5,
                color: color,
                fontFamily: "Sen-Regular",
              }}
            >
              Home
            </Text>
          ),
          tabBarIcon: ({ color, size }) => <HomeIcon color={color} size={size} />,
        }}
      />
      {/* <Tab.Screen
        name="does"
        component={DoesScreen}
        options={{
          tabBarLabel: ({ color }) => (
            // <Text style={{fontSize: 15, marginTop:-5, marginBottom: 5, color:color,fontFamily:'Sen-Regular'}}>Tuxies</Text>
            <Text
              style={{
                fontSize: 15,
                marginTop: -5,
                marginBottom: 5,
                color: color,
                fontFamily: "Sen-Regular",
              }}
            >
              Doings
            </Text>
          ),
          tabBarIcon: ({ color, size }) => <DoesIconn color={color} size={size} />,
        }}
      /> */}
      {/* Tuxys */}
      <Tab.Screen
        name="table"
        // component={MyTablesScreen}
        component={TablesNavigation}
        options={{
          tabBarLabel: ({ color }) => (
            <Text
              style={{
                fontSize: 15,
                marginTop: -5,
                marginBottom: 5,
                color: color,
                fontFamily: "Sen-Regular",
              }}
            >
              Tables
            </Text>
          ),
          tabBarIcon: ({ color, size = 24 }) => <TableIcon color={color} height={24} width={24} />,
        }}
      />

      <Tab.Screen
        name="profile"
        component={ProfileNavigation}
        options={{
          tabBarLabel: ({ color }) => (
            <Text
              style={{
                fontSize: 15,
                marginTop: -5,
                marginBottom: 5,
                color: color,
                fontFamily: "Sen-Regular",
              }}
            >
              Profile
            </Text>
          ),
          tabBarIcon: ({ color, size }) => <UserProfileIcon color={color} />,
        }}
      />
    </Tab.Navigator>
  );
}
